/* eslint-disable import/no-anonymous-default-export */
export default {
  contactInfo: "معلومات الإتصال",
  email: "الإيميل",
  phone: "الموبايل",
  groups: "المجموعات المشتركة",
};
